class MenuItem {
    constructor(key, title, url, icon = '', permission = '', children = []) {
        this.key = key
        this.title = title
        this.url = url
        this.icon = icon
        this.permission = permission
        this.children = children
    }
}

const menuData = [
    new MenuItem('dashboard', '首页', '/dashboard', 'area-chart', ''),
    new MenuItem(
        'im',
        '群组管理',
        '/im',
        'usergroup-add',
        'im_manager.im_group_list.btn_look_up'
    ),
    new MenuItem('sub-order', '订单管理', '', 'wallet', '', [
        new MenuItem(
            'process-order',
            '进行中订单',
            '/order/process/',
            '',
            'post_manager.post_process_list.btn_look_up'
        ),
        new MenuItem(
            'hunter-help',
            '猎头求助订单',
            '/hunter-help/',
            ''
        ),
        new MenuItem(
            'closed-order',
            '已关闭订单',
            '/order/closed/',
            '',
            'post_manager.post_closed_list.btn_look_up'
        ),
        new MenuItem(
            'done-order',
            '已完成订单',
            '/order/done/',
            '',
            'post_manager.post_done_list.btn_look_up'
        ),
        new MenuItem(
            'employment-order',
            '灵活用工订单',
            '/employment/',
            '',
            ''
        ),
        new MenuItem(
            'part-time-task-order',
            '赚钱任务订单',
            '/partTimeTask/',
            '',
            ''
        )
    ]),
    new MenuItem(
        'post',
        '职位管理',
        '/post',
        'deployment-unit',
        'job_manager.job_list.btn_look_up',
        [
            // new MenuItem("职位管理", "/post", "", ""),
            // new MenuItem("职位变现", "/withdrawal", "", ""),
            new MenuItem("hunter-post", "猎头职位", "/hunter-post", "", "job_manager.job_list.btn_look_up"),
            new MenuItem("post", "企业全职", "/post", "", "job_manager.fulltime_job_list.btn_look_up"),
            new MenuItem("flexible-post", "灵活用工", "/flexible-post", "", "job_manager.flexible_job_list.btn_look_up"),
            new MenuItem("money-task", "赚钱任务", "/money-task", "", "job_manager.flexible_job_list.btn_look_up"),
        ]
    ),
    new MenuItem('hunterorder', '猎头做单', '', 'project', '', [
        new MenuItem(
            'hunter-job',
            '授权简历',
            '/hunter-job',
            '',
            'head_post_manager.job_list.btn_look_up'
        ),
        // new MenuItem(
        //     'hunter-order',
        //     '做单记录',
        //     '/hunter-order',
        //     '',
        //     'head_post_manager.job_list.btn_look_up'
        // ),
        new MenuItem(
            'person-match',
            '人岗匹配',
            '/person-match',
            '',
            'head_post_manager.job_list.btn_look_up'
        )
    ]),
    new MenuItem('sub-client', '客户管理', '', 'solution', '', [
        new MenuItem(
            'client-manage',
            '客户管理',
            '/client-manage',
            '',
            'company_manager.company_list.btn_look_up'
        ),
        new MenuItem(
            'hr-manage',
            'HR管理',
            '/hr-manage',
            '',
            'company_manager.hr_list.btn_look_up'
        )
    ]),
    new MenuItem('sub-hunter', '猎头管理', '', 'crown', '', [
        new MenuItem(
            'hunter',
            '猎头管理',
            '/hunter',
            '',
            'hunter_manager.hunter_list.btn_look_up'
        ),
        new MenuItem(
            'hunter-dashboard',
            '开发数据',
            '/hunter-dashboard',
            '',
            'hunter_manager.pm_data.btn_look_up'
        ),
        new MenuItem(
            'hunter-activation',
            '激活数据',
            '/hunter-activation',
            '',
            'hunter_manager.pm_data.btn_look_up'
        )
    ]),
    new MenuItem(
        'kpi',
        'KPI数据',
        '/kpi/',
        'crown',
        ''
    ),
    new MenuItem(
        'hunter-enterprise',
        '猎企管理',
        '/hunter-enterprise',
        'crown',
        ''
    ),
    new MenuItem(
        'resume',
        '简历管理',
        '/resume/',
        'solution',
        'resume_manager.resume_list.btn_look_up'
    ),
    new MenuItem('sub-cash', '变现管理', '', 'money-collect', '', [
        new MenuItem(
            'relationship',
            '人脉变现',
            '/cash/relationship',
            '',
            'clue_manager.clue_candidate.btn_look_up'
        ),
        new MenuItem(
            'cash-job',
            '资源变现',
            '/cash/job',
            '',
            'clue_manager.job_clue.btn_look_up'
        )
    ]),
    new MenuItem('sub-organization', '组织架构管理', '', 'team', '', [
        new MenuItem(
            'organization',
            '组织架构管理',
            '/organization/setting',
            '',
            'office_setting.office_manager.btn_look_up'
        ),
        new MenuItem(
            'staff',
            '员工管理',
            '/organization/staff',
            '',
            'office_setting.staff_manager.btn_look_up'
        )
    ]),
    new MenuItem('sub-system', '系统设置', '', 'setting', '', [
        new MenuItem(
            'role',
            '角色管理',
            '/system/role',
            '',
            'system_setting.role_manager.btn_look_up'
        ),
        new MenuItem(
            'white',
            '白名单管理',
            '/system/whitelist',
            '',
            'system_setting.ip_white_manager.btn_look_up'
        ),
        // new MenuItem(
        //     'ai',
        //     'ai系统',
        //     '/system/aidemo',
        //     '',
        //     'system_setting.ip_white_manager.btn_look_up'
        // )
    ])
]
export default menuData
